import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { useQuery } from '@tanstack/react-query';
import { getProposedChallenges } from '../../api/challenge';
import ProposedChallengesListTable from './components/ProposedChallengesListTable';
import { useGetChallengeCategoriesList } from '../../queries/challenge';
import { ActionButton } from '../../components/Forms/ActionButton';
import { useGetAllUsers } from '../../queries/user';
import NewDropdown from '../../components/Forms/NewDropdown';

const ProposedChallenges = () => {

    const { data: challenges, isPending, refetch: refetchChallenges } = useQuery({
        queryKey: ['proposedChallenges'],
        queryFn: () => getProposedChallenges(),
    });

    const { data: users } = useGetAllUsers(toast);

    const { data: categoryData, isPending: isCategoryDataPending, refetch: refetchCategoryData } = useGetChallengeCategoriesList();

    const [filters, setFilters] = useState({
        fromDate: '',
        toDate: '',
        status: '',
        category: '',
        proposedBy: '',
    });

    const [filteredData, setFilteredData] = useState(challenges && challenges);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // const filteredChallenges = challenges?.filter((challenge) => {
    //     const { fromDate, toDate, status, category, proposedBy } = filters;

    //     const challengeDate = new Date(challenge.createdAt);
    //     const isWithinDateRange =
    //         (!fromDate || challengeDate >= new Date(fromDate)) &&
    //         (!toDate || challengeDate <= new Date(toDate));

    //     const matchesStatus = !status || challenge.acceptanceStatus === status;
    //     const matchesCategory = !category || challenge.category._id === category;
    //     const matchesProposedBy = !proposedBy || challenge.proposedByUser.userName.toLowerCase().includes(proposedBy.toLowerCase());

    //     return isWithinDateRange && matchesStatus && matchesCategory && matchesProposedBy;
    // });

    const handleReset = () => {
        setFilters({
            fromDate: '',
            toDate: '',
            status: '',
            category: '',
            proposedBy: '',
        });
        setFilteredData(challenges);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        let filtered = challenges;
        if (filters.fromDate) {
            filtered = filtered.filter((challenge) => new Date(challenge.createdAt) >= new Date(filters.fromDate));
        }
        if (filters.toDate) {
            filtered = filtered.filter((challenge) => new Date(challenge.createdAt) <= new Date(filters.toDate));
        }
        if (filters.status) {
            filtered = filtered.filter((challenge) => challenge.acceptanceStatus === filters.status);
        }
        if (filters.category) {
            filtered = filtered.filter((challenge) => challenge.category._id === filters.category);
        }
        if (filters.proposedBy) {
            console.log('Filtering by proposedBy:', filters.proposedBy);
            filtered = filtered.filter((challenge) => {
                console.log('Challenge proposedByUser:', challenge.proposedByUser);
                // Handle both string search and exact user object match
                if (typeof filters.proposedBy === 'string') {
                    return challenge.proposedByUser.userName.toLowerCase().includes(filters.proposedBy.toLowerCase());
                } else if (filters.proposedBy.value) {
                    // If proposedBy is an object with value property (from NewDropdown)
                    return challenge.proposedByUser.userId === filters.proposedBy.value;
                } else if (filters.proposedBy._id) {
                    // If proposedBy is a user object, match by ID
                    return challenge.proposedByUser.userId === filters.proposedBy._id;
                }
                return true;
            });
        }
        setFilteredData(filtered);
    }

    useEffect(() => {
        if (challenges) {
            setFilteredData(challenges);
        }
    }, [challenges]);

    if (isPending || isCategoryDataPending) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-xl text-gray-400">Loading...</h1>
            </div>
        );
    }

    return (
        <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">
            {/* Filters */}
            <form
                className="flex flex-col pt-5 w-full  bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)]"
                onSubmit={handleSearch}
            >
                <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap ml-5">
                    <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                        alt=""
                        className="object-contain shrink-0 w-5 aspect-square"
                    />
                    <span className="self-stretch">Filters</span>
                    <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                        alt=""
                        className="object-contain shrink-0 aspect-square w-[18px]"
                    />
                </div>
                <div className="flex flex-wrap gap-4 p-5">
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="fromDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                From Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="fromDate"
                                    value={filters.fromDate}
                                    onChange={handleFilterChange}
                                    className='flex-1'
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="toDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                To Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="toDate"
                                    value={filters.toDate}
                                    onChange={handleFilterChange}
                                    className='flex-1'
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Proposed By
                            </label>
                            <div className='mt-2'>
                                <NewDropdown
                                    dataList={users}
                                    placeholder="Select user"
                                    value={filters.proposedBy?.value || filters.proposedBy}
                                    onChange={(selectedUser) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            proposedBy: selectedUser,
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Status
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="status"
                                    value={filters.status}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All Status</option>
                                    <option value="open for voting">Open for Voting</option>
                                    <option value="voting over">Voting Over</option>
                                    <option value="live in app">Live in App</option>
                                    <option value="rejected">Rejected</option>
                                    <option value="challenge deleted">Challenge Deleted</option>
                                    <option value="challenge created(inactive)">Challenge Created (Inactive)</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Challenge Category
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="category"
                                    value={filters.category}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All</option>
                                    {challenges &&
                                        categoryData.map((category) => (
                                            <option key={category._id} value={category._id}>
                                                {category.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex gap-3 items-center justify-end p-5'>
                    <ActionButton
                        variant={'reset'}
                        text={'Reset'}
                        handleSubmit={handleReset}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Search'}
                        handleSubmit={handleSearch}
                    />
                </div>
            </form>
            <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <div className='flex items-center justify-between pr-5'>
                        <h1 className="self-start text-lg font-semibold">User Proposed Challenge List</h1>
                        <button className='p-1.5 bg-navBtn rounded' onClick={async () => {
                            await refetchChallenges();
                            await refetchCategoryData();
                            toast.success("Refreshed successfully");
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(150, 150, 150, 1)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-refresh-ccw-icon lucide-refresh-ccw"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" /><path d="M16 16h5v5" /></svg>
                        </button>
                    </div>
                    <ProposedChallengesListTable
                        data={filteredData || challenges}
                        toast={toast}
                    />
                </div>
            </section>
            <ToastContainer position="top-right" />
        </main>
    );
};

export default ProposedChallenges;